import React from 'react'
import './TrailComponent.scss'

const TrailComponent = () => {
    return (
        <section className="trial" id="trial">
            <div className="trial__box">
                <div className="trial__content">
                    <p className="trial__label">Free trial</p>
                    <h2 className="trial__title">Start your free trial now</h2>
                    <p className="trial__text">
                        Create beautiful wedding invitations, manage your guest list effortlessly,
                        and plan seating arrangements with ease. From RSVPs to final details,
                        everything you need to organize your special day is in one place.
                    </p>

                    <div className="trial__actions">
                        <button
                            className="trial__btn trial__btn--primary"
                            onClick={() => {
                                window.location.href = "/signup";
                            }}
                        >
                            Start free trial
                        </button>
                    </div>
                </div>

                <div className="trial__meta">
                    <div className="trial__item">
                        <span className="trial__itemValue">7 days</span>
                        <span className="trial__itemLabel">Trial period</span>
                    </div>
                    <div className="trial__item">
                        <span className="trial__itemValue">No card</span>
                        <span className="trial__itemLabel">Required to start</span>
                    </div>
                    <div className="trial__item">
                        <span className="trial__itemValue">Full access</span>
                        <span className="trial__itemLabel">All core features included</span>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrailComponent